import React, { Component } from 'react';
import moment from 'moment';


import LcSingsForm from './LcSignsForm';
import TrafficSignsModel from './TrafficSignsModel';
import { defaultSorter, dateSorter } from './Helpers';
import LcSignsModel from './LcSignsModel';
import UserModel from './UserModel';

import { Table, Badge, C, Card, Divider, Row, Col, Statistic, Popconfirm, Typography, message } from 'antd';

class LcSignsTable extends Component {

    state = {
        children: [],
        filteredInfo: {},
        sortedInfo: {},
        trafficSignsMessageFormData: null,
        LcSignsSettingsFormData: null
    }

    handleChange = (pagination, filters, sorter) => {
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
        });
    }

    expandedRowRender(record) {
        return (
            <div>
                <Row style={{ marginBottom: 20 }}>
                    <Col span={18}>
                        <Card title="Popis">
                            {record.description ? record.description : '-'}
                        </Card>
                    </Col>
                </Row>
                <Row style={{ marginBottom: 20 }}>
                    <Col span={10}>
                        <Card title="Událost">
                            {record.eventListener}
                        </Card>
                    </Col>
                    <Col span={8}>
                        <Card title="Schema">
                            {record.expression}
                        </Card>
                    </Col>
                    <Col span={6}>
                        <Card title="Čas zprávy z MQTT">
                            {record.lastMqttStamp ? moment(record.lastMqttStamp).format('L LTS') : '-'}
                        </Card>
                    </Col>
                </Row>
                <Row style={{ marginBottom: 20 }}>
                    <Col span={3}>
                        <Card title="IP">
                            {record.ipAddress}
                        </Card>
                    </Col>
                    <Col span={2}>
                        <Card title="Port">
                            {record.port}
                        </Card>
                    </Col>
                    <Col span={3}>
                        <Card title="Počet digitů">
                            {record.digits}
                        </Card>
                    </Col>
                    <Col span={3}>
                        <Card title="Adresa 485">
                            {record['address_485']}
                        </Card>
                    </Col>
                    <Col span={3}>
                        <Card title="tel.číslo">
                            {record.phoneNumber ? record.phoneNumber : '-'}
                        </Card>
                    </Col>
                    <Col span={3}>
                        <Card title="Z. šířka">
                            {record.latitude}
                        </Card>
                    </Col>
                    <Col span={3}>
                        <Card title="Z. výška">
                            {record.longitude}
                        </Card>
                    </Col>
                </Row>
            </div >
        );
    }

    render() {

        let { sortedInfo, filteredInfo } = this.state;

        const columns = [{
            title: 'Lokalita',
            dataIndex: 'parkingLocationName',
            key: 'parkingLocationName',
            width: 250,
            sorter: (a, b) => defaultSorter(a.parkingLocationName, b.parkingLocationName),
        }, {
            title: 'Sériové číslo',
            dataIndex: 'serialNumber',
            key: 'serialNumber',
            width: 120,
            defaultSortOrder: 'ascend',
            sorter: (a, b) => defaultSorter(a.serialnumber, b.serialnumber),
        }, {
            title: 'Zobrazeno',
            dataIndex: 'lastDisplayedNumber',
            key: 'lastDisplayedNumber',
            width: 100
        }, {
            title: 'Poslední komunikace',
            dataIndex: 'lastSendStamp',
            key: 'lastSendStamp',
            width: 200,
            sorter: (a, b) => dateSorter(a.lastSendStamp, b.lastSendStamp),
            render: (text, record) => {
                if (record.lastSendStamp) {
                    if (moment(record.lastSendStamp) <= moment().subtract(61, "minutes")) {
                        return (
                            <Badge
                                status="error"
                                text={moment(text).format('L LTS')}
                                title="Poslední komunikace před více než hodinou" />
                        );
                    } else if (moment(record.lastSendStamp) <= moment().subtract(31, "minutes")) {
                        return (
                            <Badge
                                status="warning"
                                text={moment(text).format('L LTS')}
                                title="Poslední komunikace před více než 10 minutami" />
                        );
                    } else {
                        return (
                            <Badge
                                status="success"
                                text={moment(text).format('L LTS')}
                                title="Vpořádku" />
                        );
                    }
                } else {
                    return ('-')
                }
            }
        }, {
            title: 'Běžící',
            dataIndex: 'started',
            key: 'started',
            width: 130,
            filters: [{
                text: 'ANO',
                value: true,
            }, {
                text: 'NE',
                value: false,
            }],
            filteredValue: filteredInfo.started || null,
            onFilter: (value, record) => { return ((record.started === value)) ? true : false },
            render: (text, record) => {
                if (record.started === true) {
                    return (
                        <Badge
                            status="success"
                            text="ANO" />
                    );
                } else {
                    return (
                        <Badge
                            status="error"
                            text="NE" />
                    );
                }
            }
        }, {
            title: 'Aktivní',
            dataIndex: 'active',
            key: 'active',
            width: 130,
            filters: [{
                text: 'ZAPNUTO',
                value: true,
            }, {
                text: 'VYPNUTO',
                value: false,
            }],
            filteredValue: filteredInfo.active || null,
            onFilter: (value, record) => { return ((record.active === value)) ? true : false },
            render: (text, record) => {
                if (record.active === true) {
                    return (
                        <Badge
                            status="success"
                            text="ZAPNUTO"
                        />
                    );
                } else {
                    return (
                        <Badge
                            status="error"
                            text="VYPNUTO"
                        />
                    );
                }
            }
        }, {
            title: "Ping",
            dataIndex: 'pingResult',
            key: 'pingResult',
            width: 120,
            render: (_, record) => {
                if (record.pingResult === undefined) {
                    return null; // Pokud výsledek dotazu není známý, nezobrazujte nic
                } else {
                    return record.pingResult ? record.pingResult : null;
                }
            }
        }, {
            title: 'Akce',
            key: 'Action',
            width: 300,
            render: (text, record) => {
                if (UserModel.isInRoles(['ADMIN', 'LCSIGNS_SIGNS_WRITE'])) {
                    return (
                        <div>
                            <a onClick={(e) => {
                                this.setState({
                                    LcSignsSettingsFormData: record
                                });
                            }}>Nastavení</a>
                            <Divider type="vertical" />
                            <a onClick={() => this.props.onPing(record)}><Typography.Text type="warning">Ping</Typography.Text></a>
                            <Divider type="vertical" />
                            <Popconfirm
                                placement="right"
                                title="Opravdu si přejete tuto tabulí zhasnout?"
                                okText="Ano"
                                cancelText="Ne"
                                onConfirm={() => {
                                    LcSignsModel.turnOff(record.serialNumber)
                                        .then(() => {
                                            message.success('Na LC tabuli byl odeslán turnOff!');
                                        })
                                        .catch(() => {
                                            message.error('Restart se nepodařilo odeslat!');
                                        });
                                }}>
                                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="warning">Zhasnout</Typography.Text></a>
                            </Popconfirm>
                            <Divider type="vertical" />
                            <Popconfirm
                                placement="right"
                                title="Opravdu si přejete tuto tabuli smazat?"
                                okText="Ano"
                                cancelText="Ne"
                                onConfirm={() => {
                                    LcSignsModel.remove(record.serialNumber)
                                        .then(() => {
                                            message.success('Informační tabule byla odstraněna!');
                                            this.props.onRowRemoved();
                                        })
                                        .catch(() => {
                                            message.error('Informační tabuli se nepodařilo smazat!');
                                        });
                                }}>
                                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
                            </Popconfirm>
                        </div>
                    );
                }
            }
        }]
        return (

            <div>
                <Table
                    size='small'
                    rowKey={this.props.rowKey ? this.props.rowKey : '_id'}
                    loading={this.props.loading ? this.props.loading : false}
                    columns={columns}
                    dataSource={this.props.data}
                    style={{ border: '0px' }}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
                            ? parseInt(localStorage.getItem('table_pageSize'))
                            : 10,
                        onShowSizeChange: (current, size) => {
                            localStorage.setItem('table_pageSize', size);
                        }
                    }}
                    onChange={this.handleChange}
                    expandedRowRender={this.expandedRowRender.bind(this)} />


                <LcSingsForm
                    type="modal"
                    modalVisible={this.state.LcSignsSettingsFormData === null ? false : true}
                    initialValues={this.state.LcSignsSettingsFormData}
                    onModalCancel={(form) => {
                        form.resetFields();
                        this.setState({ LcSignsSettingsFormData: null });
                    }}
                    onSuccess={(form, values) => {
                        let data = Object.assign({}, this.state.LcSignsSettingsFormData, values)
                        LcSignsModel.update(this.state.LcSignsSettingsFormData.serialNumber, data)
                            .then(() => {
                                message.success("Změna byla uložena!");
                                form.resetFields();
                                this.setState({
                                    LcSignsSettingsFormData: null
                                });
                                if (this.props.onAnyFormSuccess) {
                                    this.props.onAnyFormSuccess();
                                }
                            })
                            .catch(err => {
                                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
                            })
                    }} />
            </div>
        );
    }
}

export default LcSignsTable;


// WEBPACK FOOTER //
// ./src/components/LcSignsTable.js